"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_EN_TRANSLATIONS = exports.DE_DE_TRANSLATIONS = exports.FR_FR_TRANSLATIONS = exports.NL_NL_TRANSLATIONS = exports.FR_BE_TRANSLATIONS = exports.NL_BE_TRANSLATIONS = exports.NL_TRANSLATIONS = void 0;
const translations_nl_be_json_1 = __importDefault(require("../generator/translations_nl_be.json"));
const translations_fr_be_json_1 = __importDefault(require("../generator/translations_fr_be.json"));
const translations_nl_nl_json_1 = __importDefault(require("../generator/translations_nl_nl.json"));
const translations_fr_fr_json_1 = __importDefault(require("../generator/translations_fr_fr.json"));
const translations_de_de_json_1 = __importDefault(require("../generator/translations_de_de.json"));
const translations_en_en_json_1 = __importDefault(require("../generator/translations_en_en.json"));
exports.NL_TRANSLATIONS = translations_nl_be_json_1.default;
exports.NL_BE_TRANSLATIONS = translations_nl_be_json_1.default;
exports.FR_BE_TRANSLATIONS = translations_fr_be_json_1.default;
exports.NL_NL_TRANSLATIONS = translations_nl_nl_json_1.default;
exports.FR_FR_TRANSLATIONS = translations_fr_fr_json_1.default;
exports.DE_DE_TRANSLATIONS = translations_de_de_json_1.default;
exports.EN_EN_TRANSLATIONS = translations_en_en_json_1.default;
